import gsap from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrambleTextPlugin, SplitText, CustomEase);


import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

class Animations {
  constructor() {}
  async init() {
    //console.log("animation init");

    this.wesignHover();
    // this.initMap(); // mort : cherche id="map", inexistant (voir localite.js pour la vraie carte)
    this.heroReady = this.initPremiumHero();
    // Garde-fou : une image hero lente ne doit jamais bloquer le reste de
    // l'init ni la fin de la transition Swup (animation:in:await l'attend).
    await Promise.race([
      this.heroReady,
      new Promise((resolve) => setTimeout(resolve, 3000)),
    ]);

    document.fonts.ready.then(() => {
      // Le hero est révélé explicitement par la timeline du preloader
      // (sinon LocomotiveScroll le marque is-inview au chargement et
      // l'anim se joue invisible sous le preloader).
      this.revealText(
        document.querySelectorAll(
          ".reveal-texte:not(.section-entry .reveal-texte)"
        )
      );
    });

    const sectionAvis = document.querySelector("section.section-avis");

    if (sectionAvis) {
      const swiperAvis = new Swiper(sectionAvis.querySelector(".swiper"), {
        modules: [Navigation, Pagination, Autoplay],
        speed: 400,
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: sectionAvis.querySelector(".swiper-button-next"),
          prevEl: sectionAvis.querySelector(".swiper-button-prev"),
        },
      });
    }

    const sectionsImageTexte = document.querySelectorAll(
      "section.section-image-texte"
    );

    sectionsImageTexte.forEach((section) => {
      // --- CALCUL DE LA HAUTEUR (Isolé pour cette section) ---
      const contents = section.querySelectorAll(".grid.contenu");
      let maxHeight = 0;

      contents.forEach((content) => {
        if (content.offsetHeight > maxHeight) {
          maxHeight = content.offsetHeight;
        }
      });
      section.style.setProperty("--h", `${maxHeight}px`);

      // --- INITIALISATION SWIPER (Isolée pour cette section) ---
      const swiperContainer = section.querySelector(".swiper");
      if (swiperContainer) {
        new Swiper(swiperContainer, {
          modules: [Navigation, Pagination, Autoplay],
          speed: 400,
          loop: true,
          slidesPerView: 1,
          // autoplay: {
          //   delay: 3000,
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: section.querySelector(".swiper-button-next"),
            prevEl: section.querySelector(".swiper-button-prev"),
          },
        });
      }
    });

    const sectionFonctionnement = document.querySelector(
      "section.section-fonctionnement"
    );

    if (sectionFonctionnement) {
      const content = sectionFonctionnement.querySelector(".grid.contenu");
      const image = sectionFonctionnement.querySelector("picture");
      const height = content.offsetHeight;

      image.style.setProperty("--h", `${height}px`);
    }
  }

  wesignHover = () => {
    const wesignLink = document.querySelector("footer .copy a.wesign");
    if (!wesignLink) return;

    wesignLink.addEventListener("mouseenter", () => {
      gsap.to(wesignLink, {
        duration: 0.8, // Un peu plus long pour apprécier l'effet
        scrambleText: {
          text: "Wesign", // Le texte final à révéler
          chars: "0123456789!@#%&*<>", // Les caractères de remplacement (vibe hacker/tech)
          revealDelay: 0.2, // Temps avant que les vraies lettres ne commencent à se figer
          speed: 0.2, // Vitesse de brassage des fausses lettres
          tweenLength: true, // Garde la longueur du mot originale pour éviter que le layout saute
        },
      });
    });
  };

  initMap = async () => {
    const mapContainer = document.getElementById("map");

    // Sécurité : si l'ID map n'existe pas, on arrête la fonction pour ne pas créer d'erreur JS
    if (!mapContainer) return;

    const [{ default: maplibregl }] = await Promise.all([
      import("maplibre-gl"),
      import("maplibre-gl/dist/maplibre-gl.css"),
    ]);

    // Les coordonnées de Sept Brionne en Normandie
    const coordinates = [0.66, 49.16];

    // 1. Initialisation de la carte avec le style de ta graphiste
    const map = new maplibregl.Map({
      container: "map",
      style:
        "https://api.maptiler.com/maps/019d6d4a-f97e-7029-8123-3f23e76d1a99/style.json?key=M8gyRtOoaWXJblv0M9nZ",
      center: coordinates,
      zoom: 12,
      scrollZoom: false,
      attributionControl: false,
    });
  };

  revealText = (
    containers = document.querySelectorAll(".reveal-texte"),
    forcePlay = false
  ) => {
    CustomEase.create("osmo-ease", "0.625, 0.05, 0, 1");

    if (containers.length === 0) return;

    containers.forEach((container) => {
      if (container.classList.contains("is-split")) return;

      // 🔥 LE FIX : On cible TOUS les enfants directs (p, ul, h2, etc.)
      const children = container.children;
      if (children.length === 0) return;

      // Un <ul>/<ol> ne peut contenir que des <li> : on découpe chaque <li>
      // individuellement plutôt que d'envelopper la liste entière dans un span.
      const textBlocks = [];
      Array.from(children).forEach((child) => {
        if (child.tagName === "UL" || child.tagName === "OL") {
          Array.from(child.children).forEach((li) => textBlocks.push(li));
        } else {
          textBlocks.push(child);
        }
      });

      // On prépare un tableau pour stocker toutes les lignes de tous les enfants
      let allLines = [];

      textBlocks.forEach((child) => {
        // On crée un span pour protéger le contenu (links, strong...)
        const span = document.createElement("span");
        span.style.display = "block";
        // Une ponctuation collée juste après une balise fermante (ex:
        // <strong>Claude</strong>.) devient un mot isolé lors du split par
        // SplitText, ce qui crée un point de retour à la ligne artificiel
        // entre la balise et le ".". On la rapatrie à l'intérieur de la
        // balise pour qu'elle reste rattachée au mot précédent.
        span.innerHTML = child.innerHTML.replace(
          /(<\/[a-zA-Z]+>)([.,;:!?…]+)/g,
          "$2$1"
        );
        child.innerHTML = "";
        child.appendChild(span);

        // aria: "none" désactive l'aria-label/aria-hidden auto de SplitText :
        // ceux-ci se posent sur des rôles (generic, paragraph...) qui les
        // interdisent (règle Lighthouse "prohibited ARIA attributes"). Le
        // texte réel restant visible dans le DOM, il reste lisible nativement
        // par les lecteurs d'écran sans aucun attribut ARIA.

        // Split 1 : Les masques
        const splitMask = new SplitText(span, {
          type: "lines",
          linesClass: "line-mask",
          aria: "none",
        });

        // Split 2 : Les textes réels
        const splitInner = new SplitText(splitMask.lines, {
          type: "lines",
          linesClass: "line-inner",
          aria: "none",
        });

        // On ajoute les lignes de cet enfant au groupe global
        allLines.push(...splitInner.lines);
      });

      container.classList.add("is-split");

      // SETUP ÉTAT INITIAL
      // On cible le wrapper du masque pour cacher le débordement
      const masks = container.querySelectorAll(".line-mask");
      gsap.set(masks, { overflow: "hidden" });

      gsap.set(allLines, {
        yPercent: 120,
        rotateZ: 3,
        transformOrigin: "0% 0%",
      });

      // CRÉATION DE L'ANIMATION (sur toutes les lignes d'un coup)
      const anim = gsap.to(allLines, {
        yPercent: 0,
        rotateZ: 0,
        duration: 1.2,
        stagger: 0.05, // Stagger légèrement réduit pour un flow plus fluide sur les longs textes
        delay: 0.2,
        ease: "osmo-ease",
        paused: true,
      });

      // DÉCLENCHEMENT
      if (forcePlay || container.classList.contains("is-inview")) {
        anim.play();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.attributeName === "class" &&
              container.classList.contains("is-inview")
            ) {
              anim.play();
              observer.disconnect();
            }
          });
        });
        observer.observe(container, { attributes: true });
      }
    });
  };

  initPremiumHero = () => {
    // Navigation Swup : on stoppe le ticker et le listener resize de la page
    // précédente, sinon ils s'accumulent sur des canvas détachés.
    if (this.destroyPremiumHero) this.destroyPremiumHero();
    // Toujours définis, même sans hero (les hooks Swup les appellent)
    this.setHole = () => {};
    this.computeHole = () => {};

    const wrap = document.querySelector(".canvas-hero-wrap");
    if (!wrap) return Promise.resolve();

    const c = document.querySelector("#premium-hero-canvas");
    const ctx = c.getContext("2d");

    const offscreen = document.createElement("canvas");
    const offCtx = offscreen.getContext("2d");

    let cw, ch;
    let boxes = [];

    // VARIABLES DE LA ZONE MORTE
    let holeW = 0;
    let holeH = 0;

    let useHole = true;

    const props = {
      boxSize: 55,
      fade: true,
    };

    const T = Math.PI * 2;
    const m = {
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
      s: 1.5,
      x2: window.innerWidth / 2,
      y2: window.innerHeight / 2,
    };

    const xTo = gsap.quickTo(m, "x", { duration: 1, ease: "expo" });
    const yTo = gsap.quickTo(m, "y", { duration: 1, ease: "expo" });
    const sTo = gsap.quickTo(m, "s", { duration: 2, ease: "power2" });

    const img = new Image();
    img.src = wrap.dataset.image;

    // 🎯 CIBLAGE DES ÉLÉMENTS POUR LE CALCUL
    const textCol = document.querySelector(".section-entry .w-col-lg-8");
    const gridPattern = document.querySelector(".grid-pattern");

    this.computeHole = () => {
      const rect = textCol.getBoundingClientRect();
      holeW = rect.right + 100;
      holeH = rect.bottom + 100;

      if (gridPattern) {
        // Trou final = rectangle ancré en haut-gauche (0,0) -> (holeW, holeH).
        gridPattern.style.setProperty("--hx0", "0px");
        gridPattern.style.setProperty("--hy0", "0px");
        gridPattern.style.setProperty("--hx1", `${holeW}px`);
        gridPattern.style.setProperty("--hy1", `${holeH}px`);

        gridPattern.dataset.holeX1 = holeW;
        gridPattern.dataset.holeY1 = holeH;
      }
    };

    const resizeCanvas = () => {
      cw = wrap.clientWidth;
      ch = wrap.clientHeight;
      c.width = offscreen.width = cw;
      c.height = offscreen.height = ch;

      // --- CALCUL DYNAMIQUE DU TROU ---
      if (textCol) {
        this.computeHole();
      }

      // --------------------------------
      const imgRatio = img.width / img.height;
      const canvasRatio = cw / ch;
      let sx = 0,
        sy = 0,
        sw = img.width,
        sh = img.height;

      if (canvasRatio > imgRatio) {
        sh = img.width / canvasRatio;
        sy = (img.height - sh) / 2;
      } else {
        sw = img.height * canvasRatio;
        sx = (img.width - sw) / 2;
      }

      offCtx.clearRect(0, 0, cw, ch);
      offCtx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);

      // (Optionnel) : Si ton texte blanc est illisible sur l'image claire,
      // décommente ces deux lignes pour assombrir très légèrement l'image de fond (comme le faisait ton ancienne classe .darken)
      // offCtx.fillStyle = "rgba(0, 0, 0, 0.3)";
      // offCtx.fillRect(0, 0, cw, ch);

      boxes = [];
      for (let x = 0; x <= cw; x += props.boxSize) {
        for (let y = 0; y <= ch; y += props.boxSize) {
          boxes.push({ x, y, d: 0, s: 0 });
        }
      }
    };

    const update = () => {
      const d = Math.hypot(m.x - m.x2, m.y - m.y2);
      sTo((d / cw) * 2);

      ctx.clearRect(0, 0, cw, ch);

      // 🔥 LE FIX DU VOILE NOIR : On remet l'opacité à 100% AVANT de dessiner le fond
      ctx.globalAlpha = 1;
      ctx.drawImage(offscreen, 0, 0);

      boxes.forEach(drawBox);
    };

    const drawBox = (b) => {
      // 🛡️ APPLICATION DE LA ZONE MORTE DYNAMIQUE
      if (useHole && b.x < holeW && b.y < holeH) {
        return;
      }

      b.d = Math.hypot(b.x - m.x, b.y - m.y);
      b.s =
        1 - gsap.utils.clamp(0, 1, b.d / Math.max(cw, ch) / Math.max(m.s, 0.1));

      if (b.s < 0.001) return;

      let boxScaled = props.boxSize * b.s;
      if (props.fade) ctx.globalAlpha = b.s;

      ctx.drawImage(
        offscreen,
        b.x + boxScaled / 2,
        b.y + boxScaled / 2,
        props.boxSize - boxScaled,
        props.boxSize - boxScaled,
        b.x,
        b.y,
        props.boxSize,
        props.boxSize
      );
    };

    this.setHole = (value) => {
      useHole = value;
    };

    wrap.addEventListener("pointermove", (e) => {
      const rect = wrap.getBoundingClientRect();
      m.x2 = e.clientX - rect.left;
      m.y2 = e.clientY - rect.top;
      xTo(m.x2);
      yTo(m.y2);
    });

    const start = () => {
      resizeCanvas();
      gsap.ticker.add(update);
      window.addEventListener("resize", resizeCanvas);
      this.destroyPremiumHero = () => {
        gsap.ticker.remove(update);
        window.removeEventListener("resize", resizeCanvas);
        this.destroyPremiumHero = null;
      };
    };

    // decode() couvre le cas d'une image déjà en cache (img.onload pouvait ne
    // jamais se déclencher : canvas noir) et rejette en cas d'erreur réseau
    // au lieu de bloquer indéfiniment.
    return img.decode().then(start, () => {
      if (img.naturalWidth) start();
    });
  };
}

export default new Animations();
